"use client";

import { SharedDatasourceSubscribeDatasource } from "@/types/generated";
import useJapanAreasStore from "@/store/hooks/useGlobal";
import { useIsMobile } from "@/hooks/useIsMobile/useIsMobile";
interface DestinationFormProps {
  subscribeData: SharedDatasourceSubscribeDatasource;
  isShowUnsubscribeModal?: boolean;
}

interface SubscribeFormValues {
  firstName: string;
  lastName: string;
  email: string;
  prefecture: { value: string; label: string } | null;
}

interface SelectState {
  isFocused: boolean;
  isDisabled: boolean;
}
/**
 * DestinationForm Component
 * Displays a subscription form section for destination updates.
 * The main form UI (SubscribeForm) is currently commented out —
 * likely used for newsletter signup or marketing email subscriptions.
 */
export const DestinationForm = ({
  subscribeData,
  isShowUnsubscribeModal,
}: DestinationFormProps) => {
  const _isMobile = useIsMobile();
  const { japanAreas } = useJapanAreasStore();
  const _listRegion = japanAreas?.map((region) => ({
    id: region?.documentId || "",
    name: region?.title || "",
  }));

  return (
    <></>
    // <div className="max-md:px-4 max-md:py-10 py-20">
    //   <div className="max-md:h-full flex flex-col gap-6 rounded-3xl border border-[var(--stroke-gray-light)] p-8 shadow-xl">
    //     <div className="text-center">
    //       <div className="max-md:text-base max-md:leading-6 text-2xl leading-9 text-[var(--text-base-primary)]">
    //         <RichtextRenderer
    //           content={subscribeData.title}
    //           customStyle={{
    //             "": {
    //               fontWeight: "var(--font-semibold)",
    //               color: "var(--text-base-primary)",
    //             },
    //           }}
    //         />
    //       </div>
    //       <div className="max-md:text-xs max-md:leading-4 text-base leading-6 font-normal text-[var(--text-gray-normal)]">
    //         <RichtextRenderer content={subscribeData.description}
    //           customStyle={{
    //             "span": {
    //               fontWeight: "var(--font-normal) !important",
    //               lineHeight: isMobile ? "16px !important" : "24px !important",
    //               fontSize: isMobile ? "12px !important" : "16px !important",
    //               color: "var(--text-gray-normal) !important",
    //             },
    //             "a": {
    //               fontWeight: "var(--font-semibold) !important",
    //             }
    //           }}
    //         />
    //       </div>
    //     </div>
    //     <SubscribeForm
    //       listRegion={listRegion}
    //       subscribeData={subscribeData}
    //       isShowUnsubscribeModal={isShowUnsubscribeModal}
    //     />
    //   </div>
    // </div>
  );
};
